<app-scheda-paziente [id]="patientId"></app-scheda-paziente>